import { getCompetencySidePanelRoute, getRouteAfterRemovingCompetencySidePanel } from 'constants/helper';

export const showCompetencySidePanelService = ({
  history,
  employeeId,
  competencyId,
  levelUpCompetencyId = null,
  levelUpId,
  scrollToId,
  isOneOnOne,
  checkInInstanceId,
  // checkInParentId
}) => {
  history.push(
    getCompetencySidePanelRoute({
      location: history.location,
      employeeId,
      competencyId,
      levelUpCompetencyId,
      levelUpId,
      scrollToId,
      isOneOnOne,
      checkInInstanceId,
      // checkInParentId
    })
  );
};

export const hideCompetencySidePanelService = ({ history }) => {
  const route = getRouteAfterRemovingCompetencySidePanel({ location: history.location });
  history.push(route);
};
